import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { AppService } from 'src/app/services/app/app.service';
import { CourseService } from 'src/app/services/course/course.service';

import { DialogData } from '../../manager/calendar/dialogs/form-dialog/form-dialog.component';
import { UserManagementService } from 'src/app/services/user_management/user-management.service';
import { CommonService } from 'src/app/services/common/common.service';
import { NgxSpinnerModule } from 'ngx-spinner';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-assign-course-employee-wise',
  templateUrl: './assign-course-employee-wise.component.html',
  styleUrls: ['./assign-course-employee-wise.component.scss']
})
export class AssignCourseEmployeeWiseComponent {
public assignArr:any[]=[];
public assignObject={
  "isPublish":'0',
  'isScheduleRemoval':'',
  'isNotifyEmployee':'',
  'isSendReminder':'',

  "manager_id": "",

  "training_date": "",
  "training_time": "",
  "deadline_date": "",
  "deadline_time": "",

  "package_course_id": "",
  "t":'',
  "course_id": "",
   
  "reminder_date":'',
  'reminder_time':'',
  "reminder": "",

  'remove_date':'',
  'remove_time':'',

  "notification_msg": "",
}
minDate = new Date()
public isSpinnerLoading:boolean=false;
public errorMsg:string="";
public managerArr:any[]=[]
public courseArr:any[]=[]
timePickerStates: boolean[] = Array(4).fill(false); 
constructor(private courseService:CourseService,private appService:AppService,private spinner:NgxSpinnerModule,@Inject(MAT_DIALOG_DATA) public dialogData: any,
  public dialogRef: MatDialogRef<AssignCourseEmployeeWiseComponent>,private userManagementService:UserManagementService,
  private commonService:CommonService,private datePipe:DatePipe,
  @Inject(MAT_DIALOG_DATA) public data: DialogData,){}
ngOnInit(): void {
  //Called after the constructor, initializing input properties, and the first call to ngOnChanges.
  //Add 'implements OnInit' to the class.
  this.assignArr.push(this.assignObject)
  this.getManagerList()
  this.getCourseList()
}
onAdd(){
  let newObject={
    "isPublish":'1',
    'isScheduleRemoval':'',
    'isNotifyEmployee':'',
    'isSendReminder':'',
  
    "manager_id": "",
    "training_date": "",
    "training_time": "",
    "deadline_date": "",
    "deadline_time": "",
  
    "package_course_id": "",
    "t":'',
    "course_id": "",
     
    "reminder_date":'',
    'reminder_time':'',
    "reminder": "",
  
    'remove_date':'',
    'remove_time':'',
    // "removeapp": "",
    "notification_msg": "",
  }
this.assignArr.push(newObject)
}
onRemove(i){
  this.assignArr.splice(i,1)
}
getManagerList(){
    this.userManagementService.managerListAll().subscribe({
        next: (success: any) => {
          if (success.status == 200) {
            // this.spinner.hide()
            this.managerArr = success.data;
          }
        },
        error: (error: any) => {
          this.commonService.handleError(error)
        }}
    );
  
}
getCourseList() {
  let obj = {
    t: ""
  }
  this.isSpinnerLoading = true
  this.courseService.getAllCoursePlaylist({}).subscribe({
    next: (success: any) => {
      if (success.status) {
        this.isSpinnerLoading = false
        this.courseArr = []
        this.courseArr = success.msg
      }

    },
    error: (error: any) => { }
  })
}
onCourseList(i,event){
  let selectedItem=event.value;
  const course_item = this.courseArr.find(item => (item.c_i === selectedItem.c_i)&&(item.pc_id === selectedItem.pc_id))
  this.assignArr[i]["package_course_id"]=course_item["pc_id"]
   this.assignArr[i]['t']=course_item["t"]
   this.assignArr[i]['course_id']=course_item["c_i"]
   this.assignArr[i]['course_item']=course_item
}
validateAssignArr(): string | null {
  for (let index = 0; index < this.assignArr.length; index++) {
    const formData = this.assignArr[index];

    if (formData.isNotifyEmployee && !formData.notification_msg) {
      return `Item ${index + 1}: Notification message is necessary when Notify Employee is true.`;
    }

    if (!formData.training_date || !formData.training_time ||
        !formData.deadline_date || !formData.deadline_time) {
      return `Item ${index + 1}: Training date, training time, deadline date, and deadline time are necessary.`;
    }

    if (formData.isScheduleRemoval && (!formData.remove_date || !formData.remove_time)) {
      return `Item ${index + 1}: Remove date and remove time are necessary when Schedule Removal is selected.`;
    }

    if (formData.isSendReminder && (!formData.reminder_date || !formData.reminder_time)) {
      return `Item ${index + 1}: Reminder date and reminder time are necessary when Send Reminder is selected.`;
    }

    if (!formData.course_id) {
      return `Item ${index + 1}: Course is necessary.`;
    }
  }

  return null; // No errors
}
onSubmit(){
  this.errorMsg='';
  const firstValidationError = this.validateAssignArr();

  if (firstValidationError) {
    // Display or handle the first validation error
    this.errorMsg=firstValidationError;
    console.error('Validation error:', firstValidationError);
  } else {
    // Proceed with submission
    // ...
    this.onAssignCourse()
  }
}
onAssignCourse(){
  let newArray :any[]=[]
  newArray=[...this.assignArr]
  newArray.map((item)=>{
    delete item["isScheduleRemoval"]
    delete item["isNotifyEmployee"]
    delete item["isSendReminder"]
    delete item["isSendReminder"]
    item["deadline_date"]=this.datePipe.transform(item["deadline_date"],'yyyy-MM-dd')
    item["training_date"]=this.datePipe.transform(item["training_date"],'yyyy-MM-dd')
    item["remove_date"]=this.datePipe.transform(item["remove_date"],'yyyy-MM-dd')
    item["reminder_date"]=this.datePipe.transform(item["remove_date"],'yyyy-MM-dd')
    item["removeapp"] = item ["remove_date"] + item ["remove_time"] 
    delete item["remove_date"]
    delete item["remove_time"]
  })
  let obj={
    "employee_id": this.dialogData.id,
    "assign_data" :newArray
  }
  this.courseService.assignCourseEmployee(obj).subscribe({
    next: (success: any) => {
      if (success.status==200) {
        this.appService.showToastMessage('success',success.msg)
        this.dialogRef.close({data_added:true});
      }
    },
    error: (error: any) => { 
      this.commonService.handleError(error.msg)
    }
  })
}

}
